import { render, staticRenderFns } from "./PPIS.vue?vue&type=template&id=65605bc9&scoped=true"
import script from "./PPIS.vue?vue&type=script&lang=js"
export * from "./PPIS.vue?vue&type=script&lang=js"
import style0 from "./PPIS.vue?vue&type=style&index=0&id=65605bc9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65605bc9",
  null
  
)

export default component.exports